import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { uploadFile } from "../../../../../apis/common-apis/fileApi";

export const useFileUpload = (control, refetch, setIsUploadDialogOpen) => {
  const [isLoading, setIsLoading] = useState(false);
  const { getAccessTokenSilently, getIdTokenClaims } = useAuth0();

  const handleFileUpload = async (file) => {
    setIsLoading(true);
    const controlId = control?.controlsId;

    if (!file || !controlId) {
      alert("Invalid file or control ID!");
      setIsLoading(false);
      return;
    }

    try {
      const accessToken = await getAccessTokenSilently();
      const idToken = (await getIdTokenClaims()).__raw;

      await uploadFile(
        file,
        "control_evidence",
        controlId,
        undefined,
        accessToken,
        idToken,
        undefined, // ownerEmployeeId is not used in this context
        true
      );

      refetch();
      setIsUploadDialogOpen(false);
      alert("Evidence uploaded successfully!");
    } catch (error) {
      console.error("Upload error:", error);
      alert("Evidence upload failed!");
    }

    setIsLoading(false);
  };

  return {
    isLoading,
    handleFileUpload,
  };
};
